module.exports = __webpack_public_path__ + "img/retrospect-process-3-mobile.aa09b840.jpg";